<template>
  <div class="form-container" style="position: relative">
    <el-form ref="form" label-position="top" :rules="rules" :model="formLabelAlign" label-width="80px" class="order-form">
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item prop="firstName">
          <label slot="label">{{ $t('first_name') }}</label>
            <el-input class="gray-theme" v-model="formLabelAlign.firstName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="lastName">
          <label slot="label">{{ $t('last_name') }}</label>
            <el-input class="gray-theme" v-model="formLabelAlign.lastName" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="6">
          <el-form-item prop="title" style="width: 100%">
            <template>
              <label slot="label">{{ $t('title') }}</label>
              <el-select v-model="formLabelAlign.title" class="gray-theme" disabled>
                <el-option
                  v-for="item in titleOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="type">
            <label slot="label">{{ $t('role') }}</label>
            <template>
              <el-select v-model="formLabelAlign.type" disabled class="gray-theme">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="email">
            <label slot="label">{{ $t('email') }}</label>
            <el-input class="gray-theme" v-model="formLabelAlign.email" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="cellphone">
            <label slot="label">{{ $t('cellphone') }}</label>
            <el-input class="gray-theme" v-model="formLabelAlign.cellphone" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item prop="company" style="width: 100%">
            <label slot="label">{{ $t('company') }}</label>
            <el-input class="gray-theme" v-model="formLabelAlign.company" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="country" style="width: 100%">
            <label slot="label">{{ $t('country') }}</label>
            <el-select v-model="formLabelAlign.country" class="gray-theme" filterable style="width: 100%" disabled>
              <el-option
                v-for="item in countryOptions"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="zip" style="width: 100%">
            <label slot="label">{{ $t('zip') }}</label>
            <el-input class="gray-theme" v-model="formLabelAlign.zip" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item prop="state" style="width: 100%">
            <label slot="label">{{ $t('state') }}</label>
            <el-input class="gray-theme" v-model="formLabelAlign.state" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="city" style="width: 100%">
            <label slot="label">{{ $t('city') }}</label>
            <el-input class="gray-theme" v-model="formLabelAlign.city" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="24">
          <el-form-item prop="address" style="width: 100%">
            <label slot="label">{{ $t('address') }}</label>
            <el-input maxlength="100" class="gray-theme" v-model="formLabelAlign.address" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="address2" style="width: 100%">
            <label slot="label">{{ $t('address2') }}</label>
            <el-input maxlength="100" class="gray-theme" v-model="formLabelAlign.address2" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import commonApi from '@/apis/common';
import userApi from '@/apis/user';
export default {
  data() {
    var checkMoney = (rule, value, callback) => {
      if (value === '') {
        callback();
        return;
      }
      if (!this.$formValidation.twoPointreg.test(value)) {
        callback(new Error('Mony format error '));
        return;
      }
      if (value < 0 || value > 9999999999999.99) {
        callback(new Error('Mony format error '));
        return;
      }
      callback();
    };
    return {
      formLabelAlign: {
        fritsName: '',
        lastName: '',
        email: '',
        cellphone: '',
        address: '',
        type: '',
        erpappInstNumber: '',
        active: ''
      },
      titleOptions: [
        {
          name: 'Mr',
          code: '0'
        },
        {
          name: 'Mrs',
          code: '1'
        },
        {
          name: 'Ms',
          code: '2'
        },
        {
          name: 'Miss',
          code: '3'
        },
        {
          name: 'Dr',
          code: '4'
        },
        {
          name: 'Prof',
          code: '5'
        },
        {
          name: 'other',
          code: '6'
        }
      ],
      countryOptions: [],
      typeOptions: [
        {
          name: this.$t('user'),
          code: 10
        },
        {
          name: this.$t('dealer'),
          code: 20
        }
      ],
      currencyListData: [],
      rules: {
        amount: [
          { validator: checkMoney, trigger: 'blur' },
          {
            required: true,
            message: 'Money is required',
            trigger: 'blur'
          }
        ]
      }
    };
  },

  props: {
    rowVal: {
      type: Object,
      default: () => {}
    },

    readModel: {
      type: Boolean,
      default: true
    }
  },

  components: {},

  computed: {},

  mounted() {
    this.init();
    userApi.getCountry().then(response => {
      this.countryOptions = response.list;
    });
  },

  methods: {
    init() {
      console.log(this.rowVal);
      this.formLabelAlign = this.rowVal;
      this.getCurrency();
    },

    async getCurrency() {
      const req = {};
      const res = await commonApi.getCurrency(req);
      console.log(res);
      this.currencyListData = res.list;
    }
  }
};
</script>
<style lang="scss">
.order-form {
  .el-form-item__label {
    float: left;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #292929;
    padding: 0;
  }

  .el-form-item__content {
    // width: 320px;
  }
}

.order-form-title {
  font-size: 24px;
  font-weight: bold;
  text-align: left;
  color: #292929;
  padding: 30px 0;
}

.line {
  height: 1px;
  background: #f4f4f4;
}

.dialog-class {
  border-radius: 14px !important;
  .el-dialog__header {
    background-color: #f4f4f4;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    padding: 50px 0 20px 50px;
  }

  .el-dialog__body {
    height: 50vh;
    overflow: auto;
    padding: 40px 165px 0;
  }
}
</style>
